import request from "./request.js";

export default {
  getSmscode(data) {
    return request.post("/comm/comsmsapi/phcode", data);
  },
  getSwiperList(data) {
    return request.post("/main/web/cals", data);
  },
  getJobList(data) {
    return request.post("/main/appjob/query", data);
  },
  getJobTypeTree(data) {
    return request.post("/main/job/tptree", data);
  },
  getDictionary(data) {
    return request.post("/comm/comapi/dictionary", data);
  },
  doSuggestion(data) {
    return request.post("/main/appusr/cplsave", data);
  },
  userRegister(data) {
    return request.post("/ums/app/reguserph", data);
  },
  getAddressStep(data) {
    return request.get("/shop/city_list_pid?pid=" + data.pid);
  },
  wkexpsave(data) {
    return request.post("/main/appwk/wkexpsave", data);
  },
  checkLicense(data) {
    return request.post("/comm/comocrapi/bzlicense", data);
  },
  saveCompanyInfo(data) {
    return request.post("/main/appcpy/webapply", data);
  },
  getNoticeList(data) {
    return request.post("/main/web/notices", data);
  },
  getNoticeDetails(data) {
    return request.post("/main/web/noticeinfo", data);
  },
  searchKeys(data) {
    return request.post("/main/web/searchkeys", data);
  },
  getJobListFilter(data) {
    return request.post("/main/web/queryjobs", data);
  },
  getJobListNew(data) {
    return request.post("/main/appNewjob/querynNew", data);
  },
  getJobListNoToken(data) {
    return request.post("/main/web/jobs", data);
  },
  getSearchCitys(data) {
    return request.post("/main/web/searchcitys", data);
  },
  getWorkerTypes(data) {
    return request.post("/main/web/workjobtypes", data);
  },
  getWorkersHot(data) {
    return request.post("/main/web/workers", data);
  },
  getWorkerList(data) {
    return request.post("/main/web/queryworkers", data);
  },
  getJobDetail(data) {
    return request.post("/main/web/jobdetail", data);
  },
  getWorkerDetail(data) {
    return request.post("/main/web/workerdetail", data);
  },
  getUserInfo(data) {
    return request.post("/main/web/myinfo", data);
  },
  getAdv(data) {
    return request.post("/main/web/advertise", data);
  },
  saveIntention(data) {
    return request.post("/main/appwk/webapply", data);
  },
  destoryUser(data) {
    return request.post("/ums/app/destroyed", data);
  },
  getWeixinScheme(data) {
    return request.post("/comm/mpapi/geturlscheme", data);
  },
  getCpyIntroduce(data){
    return request.post("/main/apphome/cpyintroduce",data)
  },
  getRegUserByInvite(data) {
    return request.post("/main/appusr/regUserByInvite", data);
  },
  submitPhoneNumber(data) {
    return request.post("/main/pc/phone", data);
  },
  submitFeedback(data) {
    return request.post("/main/pc/feedback", data);
  },
  getAgreementInfoByKey(data) {
    return request.post("/comm/appSysData/getAgreementInfoByKey", data);
  },
  // PC端-招聘列表
  getRecruitmentList(data) {
    return request.get("/main/pc/recruitment/list?pageNum="+data.pageNum+"&pageSize="+data.pageSize);
  },
  getRecommendJobList(data) {
    return request.get("/main/pc/jobSearchRecord/list?pageNum="+data.pageNum+"&pageSize="+data.pageSize);
  },
  getWechat(url) {
    return request.get(`/comm/api/wechat/config?url=${encodeURIComponent(url)}`);
  },
  getCopDetail(data) {
    return request.post("/main/appcpy/info", data);
  },
  getJobsDetail(data) {
    return request.post("/main/appjob/detail", data);
  },

// 查询用户简历信息 by code
  queryUserResumeInfo(data) {
    return request.post("/appCenter/resumeApp/queryShareResumeByCode", data);
  },
  // 查询用户简历信息 by workerUserId（压缩短信链接解密后）
  queryShareResumeByWid(data) {
    return request.get(`/appCenter/resumeApp/queryShareResumeByWid?wid=${data.workerUserId}`);
  }
};
